export default __webpack_public_path__ + "static/media/remove_icon.475004bf.svg";